import React from 'react';
import { formatLicenseDeviceInfo, formatLicenseExpiry } from '../utils/deviceInfo';
import './LicenseDetailsModal.css';

const LicenseDetailsModal = ({ license, onClose }) => {
  const getStatusClass = () => {
    if (license.status === 'active' && license.device_id) return 'status-active';
    if (license.status === 'active' && !license.device_id) return 'status-pending';
    if (license.status === 'inactive') return 'status-inactive';
    return 'status-expired';
  };

  const getStatusText = () => {
    if (license.status === 'active' && license.device_id) return 'Active';
    if (license.status === 'active' && !license.device_id) return 'Pending Activation';
    if (license.status === 'inactive') return 'Inactive';
    return 'Expired';
  };

  return (
    <div className="details-overlay" onClick={onClose}>
      <div className="details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="details-header">
          <h2>📄 License Details</h2>
          <button onClick={onClose} className="details-close">
            &times;
          </button>
        </div>

        <div className="details-content">
          <div className="details-section">
            <h3 className="details-section-title">🔑 License Information</h3>
            <div className="details-row">
              <span className="details-label">License Key:</span>
              <code className="details-code">{license.license_key}</code>
            </div>
            <div className="details-row">
              <span className="details-label">Status:</span>
              <span className={`details-status ${getStatusClass()}`}>
                {getStatusText()}
              </span>
            </div>
          </div>

          <div className="details-section">
            <h3 className="details-section-title">👤 Client Information</h3>
            <div className="details-row">
              <span className="details-label">Client Name:</span>
              <span className="details-value">{license.client_name}</span>
            </div>
            <div className="details-row">
              <span className="details-label">Email:</span>
              <span className="details-value">{license.email}</span>
            </div>
          </div>

          {(license.device_info || license.mac_address) && (
            <div className="details-section">
              <h3 className="details-section-title">💻 Device Information</h3>
              <div className="details-row">
                <span className="details-value">{formatLicenseDeviceInfo(license)}</span>
              </div>
            </div>
          )}

          {(license.expires_at || license.expiry_days) && (
            <div className="details-section">
              <h3 className="details-section-title">📅 Timeline</h3>
              <div className="details-row">
                <span className="details-label">Expiry Date:</span>
                <span className="details-value">{formatLicenseExpiry(license)}</span>
              </div>
            </div>
          )}

          {license.notes && (
            <div className="details-section details-notes">
              <h3 className="details-section-title">📝 Notes</h3>
              <div className="details-notes-content">
                {license.notes}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LicenseDetailsModal;